module.exports = __webpack_public_path__ + "img/vip_room_min_2.2cc787c5.png";